// Subgroup filters offered on the Statistics screen. Keys and values match the
// backend registry (GET /dm/data/filters); labels are i18n keys.
export const SUBGROUP_FILTERS = [
  {
    key: "gestation",
    label: "subgroup.gestation",
    values: [
      { value: "preterm", label: "subgroup.preterm" },
      { value: "term", label: "subgroup.term" },
    ],
  },
  {
    key: "ethnicity",
    label: "subgroup.ethnicity",
    values: [
      { value: "kinh", label: "subgroup.kinh" },
      { value: "minority", label: "subgroup.minority" },
    ],
  },
  {
    key: "award",
    label: "subgroup.award",
    values: [
      { value: "awarded", label: "subgroup.awarded" },
      { value: "not_awarded", label: "subgroup.notAwarded" },
    ],
  },
  {
    key: "baby_sex",
    label: "subgroup.babySex",
    values: [
      { value: "boy", label: "subgroup.boy" },
      { value: "girl", label: "subgroup.girl" },
    ],
  },
];

export const hasActiveFilters = (filters) => Object.values(filters || {}).some((value) => value && value !== "all");

// Human-readable list of the chosen values, e.g. "Sinh non · Dân tộc thiểu số"
export const describeFilters = (filters, t) =>
  SUBGROUP_FILTERS.map((filter) => {
    const chosen = filter.values.find((v) => v.value === filters?.[filter.key]);
    return chosen ? t(chosen.label) : null;
  })
    .filter(Boolean)
    .join(" · ");
